import { render } from "./AppToggleSwitch.vue?vue&type=template&id=2b72d7cc&scoped=true&ts=true"
import script from "./AppToggleSwitch.vue?vue&type=script&lang=ts"
export * from "./AppToggleSwitch.vue?vue&type=script&lang=ts"

import "./AppToggleSwitch.vue?vue&type=style&index=0&id=2b72d7cc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b72d7cc"]])

export default __exports__